





























import { Component, Vue } from 'vue-property-decorator';
import Tabs from '@/components/tabs/Tabs.vue';
import Tab from '@/components/tabs/Tab.vue';
import LayersTab from '@/components/tabs/LayersTab.vue';
import CustomTab from '@/components/tabs/CustomTab.vue';
import EditorType from '@/EditorType';
import ComponentsTab from '@/components/tabs/ComponentsTab.vue';
import { mapGetters } from 'vuex';
import DataComponentsTab from '@/components/tabs/DataComponentsTab.vue';
import { OverviewNodes } from '@/nodes/overview/Types';

@Component({
  components: {
    DataComponentsTab,
    ComponentsTab,
    CustomTab,
    LayersTab,
    Tab,
    Tabs,
  },
  computed: mapGetters(['currEditorType']),
})
export default class Sidebar extends Vue {
  private editorType = EditorType;
  private overviewCustomNode = OverviewNodes.Custom;
}
